namespace Portico.Models.Pdf {
    export class AddDocumentRequestModel {
        public programId: number;
        public pdfRequest: PdfRequest;
    }
}

